import axios from 'axios';
import type { BundleDefaultComponent, BundleDefaultListEntry } from '../schemas/apiResponse.schemas';
import {
  BundleDefaultAddResponseSchema,
  BundleDefaultComponentRemoveResponseSchema,
  BundleDefaultComponentResponseSchema,
  BundleDefaultDeleteResponseSchema,
  BundleDefaultListResponseSchema,
} from '../schemas/apiResponse.schemas';
import { validateResponse } from './validateResponse';

const API_BASE = '/api/bundle-defaults';

export async function fetchBundleDefaults(): Promise<BundleDefaultListEntry[]> {
  const response = await axios.get(API_BASE);
  const parsed = validateResponse(BundleDefaultListResponseSchema, response.data, 'fetchBundleDefaults');
  return parsed.entries;
}

export async function createBundleDefaultList(parentSku: string): Promise<BundleDefaultListEntry> {
  const response = await axios.post(API_BASE, { parent_sku: String(parentSku).trim() });
  const parsed = validateResponse(BundleDefaultAddResponseSchema, response.data, 'createBundleDefaultList');
  return parsed.entry;
}

export async function deleteBundleDefaultList(parentSku: string): Promise<void> {
  const response = await axios.delete(`${API_BASE}/${encodeURIComponent(parentSku)}`);
  validateResponse(BundleDefaultDeleteResponseSchema, response.data, 'deleteBundleDefaultList');
}

export async function copyBundleDefaultsFromPim(parentSku: string): Promise<BundleDefaultListEntry> {
  const response = await axios.post(`${API_BASE}/${encodeURIComponent(parentSku)}/copy-from-pim`);
  const parsed = validateResponse(BundleDefaultAddResponseSchema, response.data, 'copyBundleDefaultsFromPim');
  return parsed.entry;
}

export async function addBundleDefaultComponent(
  parentSku: string,
  componentSku: string,
  quantity: number,
): Promise<BundleDefaultComponent> {
  const response = await axios.post(`${API_BASE}/${encodeURIComponent(parentSku)}/components`, {
    component_sku: String(componentSku).trim(),
    quantity,
  });
  const parsed = validateResponse(
    BundleDefaultComponentResponseSchema,
    response.data,
    'addBundleDefaultComponent',
  );
  return parsed.component;
}

export async function updateBundleDefaultComponentQuantity(
  parentSku: string,
  componentId: number,
  quantity: number,
): Promise<BundleDefaultComponent> {
  const response = await axios.patch(
    `${API_BASE}/${encodeURIComponent(parentSku)}/components/${componentId}`,
    { quantity },
  );
  const parsed = validateResponse(
    BundleDefaultComponentResponseSchema,
    response.data,
    'updateBundleDefaultComponentQuantity',
  );
  return parsed.component;
}

export async function removeBundleDefaultComponent(parentSku: string, componentId: number): Promise<void> {
  const response = await axios.delete(
    `${API_BASE}/${encodeURIComponent(parentSku)}/components/${componentId}`,
  );
  validateResponse(
    BundleDefaultComponentRemoveResponseSchema,
    response.data,
    'removeBundleDefaultComponent',
  );
}
